import React, { useState, useEffect } from 'react';
import api from '../../../api';
import ArtistComponent from './ArtistComponent';
import ProfileHeader from './ProfileHeader';
import CustomerInfo from './CustomerInfo';
import AddArtistComponent from './AddArtistComponent';

const ProfileDetailsView = ({ data }) => {
  const [editMode, setEditMode] = useState({});
  const [editedNames, setEditedNames] = useState({});

  useEffect(() => {
    const initialEditMode = {};
    const initialEditedNames = {};
    data?.artists?.forEach(artist => {
      initialEditMode[artist.id] = false;
      initialEditedNames[artist.id] = artist.name;
    });
    setEditMode(initialEditMode);
    setEditedNames(initialEditedNames);
  }, [data]);

  const handleEditToggle = (artistId) => {
    setEditMode(prev => ({ ...prev, [artistId]: !prev[artistId] }));
  };

  const handleNameChange = (artistId, newName) => {
    setEditedNames(prev => ({ ...prev, [artistId]: newName }));
  };

  const handleUpdate = async (artistId) => {
    try {
      await api.updateArtistName(artistId, editedNames[artistId]);
      setEditMode(prev => ({ ...prev, [artistId]: false }));
    } catch (error) {
      console.error('Error updating artist name:', error);
    }
  };

  const handleDeleteArtist = async (artistId) => {
    try {
      await api.deleteArtist(artistId);
      data.artists = data.artists.filter(artist => artist.id !== artistId);
    } catch (error) {
      console.error('Error deleting artist:', error);
    }
  };

  if (!data) return null;

  return (
    <div className="p-4 bg-blue-50 text-gray-800">
      <ProfileHeader 
        username={data.username}
        bio={data.bio}
        created={data.created}
        is_followed={data.is_followed}
        is_seller={data.is_seller}
      />

      {/* <CustomerInfo customer_info={data.customer_info} /> */}

      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2 text-blue-700">Artists</h3>
        <AddArtistComponent />
        {data.artists && data.artists.length > 0 ? (
          <ul className="list-disc pl-5">
            {data.artists.map((artist) => (
              <ArtistComponent 
                key={artist.id}
                artist={{ ...artist, name: editedNames[artist.id] ?? artist.name }}
                isEditMode={editMode[artist.id]}
                onEditToggle={handleEditToggle}
                onNameChange={handleNameChange}
                onUpdate={handleUpdate}
                onDelete={handleDeleteArtist}
              />
            ))}
          </ul>
        ) : (
          <p className="text-sm">No artists data.</p>
        )}
      </div>
    </div>
  );
};

export default ProfileDetailsView;
